
  export default {
    data () {
      return {
        fields: ['fee_debit_card_amount', 'fee_contactless', 'tx_atm', 'tx_lodgement', 'fee_so_setup', 'fee_so_commission', 'tx_so',
                 'fee_so_amend', 'fee_so_unpaid', 'fee_dd_setup', 'tx_dd', 'fee_dd_unpaid', 'fee_chq_unpaid',
                 'fee_chq_unpaid_inward', 'fee_referral', 'fee_replace_loststolen_card', 'fee_stop_instruction',
                 'fee_replace_pin', 'fee_credit_tfer', 'fee_dup_stmt']
      };
    },
    computed: {
      current () {
        return this.$store.state.products.current;
      }
    }
  };
